import type { ComponentProps } from "react";
import { AdminDataNotice } from "@/components/admin/data-notice";
import { BillingView } from "@/components/admin/billing-view";
import { useAdminView } from "@shared/client/admin-view";
import { usePageTitle } from "@shared/client/view";
import { AdminMeta } from "@shared/components/blocks";

type BillingData = ComponentProps<typeof BillingView>;

export default function AdminBillingPage() {
  usePageTitle("Facturation — Administration Hune");
  const { data, error } = useAdminView<BillingData>("/api/views/admin/billing");
  return (
    <>
      <AdminMeta note="Consommation sur 30 jours glissants">Plans, abonnements et consommation de chaque compte</AdminMeta>
      {error ? <AdminDataNotice error={error} /> : data ? <BillingView {...data} /> : null}
    </>
  );
}
